<template>
    <div>
        <div class="sluzba-intro" style="background-image: url('/theme/images/sluzby/img_eshop.jpg'); background-size: cover;">
            <div class="block-container heading-block">
                <h1>Tvoříme weby<span class="red">.</span></h1>
            </div>
            <div class="block-padding-lr">
                <div class="line"></div>
            </div>
            <div class="block-container">
                <div class="intro-cols">
                    <div class="first-col">
                        <p>Multidisciplinary product designer specializing in systems, experience and interaction.Currently at Cash App </p>
                    </div>
                    <div class="second-col">
                        <p>I'm a designer currently based in Seattle, where I'm part of the design team at Cash App. As a multidisciplinary designer, I specialize in interaction, visual, brand, motion, and more. I'm passionate about crafting seamless user experiences and thrive on challenges that demand creativity and innovation.</p>
                    </div>
                </div>
            </div>
        </div>
        <div id="reference-kare" class="sluzby-reference-grid">
            <div class="sluzby-reference-item--web-media">
                <picture>
                    <source srcset="/theme/images/klienti/opice.jpg">
                    <img class="sluzby-reference-item--web-media__image" src="/theme/images/klienti/opice.jpg" alt="Kare web">
                </picture>
            </div>
            <div 
                class="sluzby-reference-item sluzby-reference-item--web reference-item-3 reference-item-padding-lr reference-item-padding-tb"
                style=""
            >
                <div class="reference-item-3-text">
                    <span class="sluzby-reference-label">Kare</span>
                    <h2>Kare e-shop</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae explicabo suscipit nemo est! Possimus voluptatem id quas. Nulla libero illo quo aut architecto, vero eius, laborum natus minima, commodi quaerat.</p>
                </div>
                <div class="reference-item-3-img-wrapper">
                    <img src="/theme/images/klienti/kare.png" alt="">
                </div>
            </div>
        </div>
        <div id="reference-oooox" class="sluzby-reference-grid">
            <div class="sluzby-reference-item--web-media">
                <picture>
                    <source srcset="/theme/images/sluzby/web/oooox.webp">
                    <img class="sluzby-reference-item--web-media__image" src="/theme/images/sluzby/web/oooox.jpg" alt="OOOOX web">
                </picture>
                <div class="sluzby-reference-item--web-media__yt-video">
                    <iframe width="1345" height="825" data-src="https://www.youtube.com/embed/b6wckpW7o1I?controls=0&modestbranding=1&rel=0&mute=1&autoplay=1&loop=1&playlist=b6wckpW7o1I" autoplay muted allowfullscreen></iframe>
                </div>
            </div>
            <div 
                class="sluzby-reference-item sluzby-reference-item--web reference-item-3 reference-item-padding-lr reference-item-padding-tb"
                style=""
            >
                <!--
                    <div>
                        <h2>Online portfolio pro architektonické Studio OOOOX</h2>
                        <p>Klientky přicházející do MEDICOM Clinic musí získat ten nejlepší první dojem. Tak musí působit i brožury a tiskové materiály, které dostanou.</p>
                    </div>
                -->
            </div>
        </div>
        <div id="reference-sonet" class="sluzby-reference-grid">
            <div class="sluzby-reference-item--web-media">
                <picture>
                    <source srcset="/theme/images/sluzby/web/sonet.webp">
                    <img class="sluzby-reference-item--web-media__image" src="/theme/images/sluzby/web/sonet.jpg" alt="Sonet web">
                </picture>
            </div>
            <div 
                class="sluzby-reference-item sluzby-reference-item--web reference-item-3 reference-item-padding-lr reference-item-padding-tb"
                style=""
            >
                <div class="sluzby-reference-item--web__content sluzby-reference-item--web__content--l"></div>
                <div class="sluzby-reference-item--web__content sluzby-reference-item--web__content--r">
                    <img class="sluzby-reference-item--web__logo" src="/theme/images/sluzby/web/logo_sonet.svg" alt="Sonet logo">
                    <h2>Přední česká firma komplexní služby v oblasti platebních technologií.</h2>
                    <p>Klientky přicházející do MEDICOM Clinic musí získat ten nejlepší první dojem. Tak musí působit i brožury a tiskové materiály, které dostanou.</p>
                </div>
            </div>
        </div>
        <div id="reference-cofee" class="sluzby-reference-grid">
            <div class="sluzby-reference-item--web-media">
                <picture>
                    <source srcset="/theme/images/sluzby/web/cofee.webp">
                    <img class="sluzby-reference-item--web-media__image" src="/theme/images/sluzby/web/cofee.png" alt="Cofee web">
                </picture>
            </div>
            <div 
                class="sluzby-reference-item sluzby-reference-item--web reference-item-3 reference-item-padding-lr reference-item-padding-tb"
                style=""
            >
                <div class="sluzby-reference-item--web__content sluzby-reference-item--web__content--l">
                    <h2>Web pro</h2>
                    <img class="sluzby-reference-item--web__logo" src="/theme/images/sluzby/web/logo_cofee.svg" alt="Cofee logo">
                    <p>Klientky přicházející do MEDICOM Clinic musí získat ten nejlepší první dojem. Tak musí působit i brožury a tiskové materiály, které dostanou.</p>
                </div>
                <div class="sluzby-reference-item--web__content sluzby-reference-item--web__content--r"></div>
            </div>
        </div>
        <div id="reference-pzk" class="sluzby-reference-grid">
            <div class="sluzby-reference-item--web-media">
                <picture>
                    <source srcset="/theme/images/sluzby/web/pzk.webp">
                    <img class="sluzby-reference-item--web-media__image" src="/theme/images/sluzby/web/pzk.png" alt="PZK web">
                </picture>
            </div>
            <div 
                class="sluzby-reference-item sluzby-reference-item--web reference-item-3 reference-item-padding-lr reference-item-padding-tb"
                style=""
            >
                <div class="sluzby-reference-item--web__content sluzby-reference-item--web__content--l"></div>
                <div class="sluzby-reference-item--web__content sluzby-reference-item--web__content--r">
                    <img class="sluzby-reference-item--web__logo" src="/theme/images/sluzby/web/logo_pzk.svg" alt="PZK logo">
                    <h2>Přední česká firma komplexní služby v oblasti platebních technologií.</h2>
                    <p>Klientky přicházející do MEDICOM Clinic musí získat ten nejlepší první dojem. Tak musí působit i brožury a tiskové materiály, které dostanou.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            sluzba_id: {
                type: Number,
            },
        },
        mounted() {
            const videoContainers = document.querySelectorAll('.sluzby-reference-item--web-media');

            videoContainers.forEach(container => {
                const video = container.querySelector('video');
                const youtubeIframe = container.querySelector('iframe[data-src]');

                if (video) {
                    const observer = new IntersectionObserver(entries => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                video.load();
                                video.addEventListener('canplaythrough', function videoReady() {
                                    container.classList.add('sluzby-reference-item--web-media--video-loaded');
                                    video.play();
                                    video.removeEventListener('canplaythrough', videoReady);
                                });
                                video.addEventListener('error', function(error) {
                                    console.error('Chyba při načítání videa:', error);
                                });
                                observer.disconnect();
                            }
                        });
                    });
                    observer.observe(video);
                }

                if (youtubeIframe) {
                    const observer = new IntersectionObserver(entries => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                youtubeIframe.src = youtubeIframe.dataset.src;
                                youtubeIframe.setAttribute('muted', '');
                                youtubeIframe.setAttribute('allow', 'autoplay; encrypted-media');
                                youtubeIframe.setAttribute('allowfullscreen', '');
                                youtubeIframe.setAttribute('autoplay', '');
                                youtubeIframe.removeAttribute('data-src');
                                container.classList.add('sluzby-reference-item--web-media--video-loaded');
                                observer.disconnect();
                            }
                        });
                    });
                    observer.observe(youtubeIframe);
                }
            });
        },
    }
</script>

<style lang="scss" scoped>
p{
    font-size: 18px;
    line-height: 1.6;
};
.sluzba-2-intro{
    // background-color: #cdcdcd;
    color: white;
    position: relative;
    .bgvid{
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        top: 0px;
        left: 0px;
        z-index: -1;
        // opacity: 0.9;
    }
    h1{
        font-size: 92px;
        line-height: 1;
        font-weight: 600;
        .red{
            color: red;
        }
        @media screen and (max-width: 1600px) {
            font-size: 82px;
        }
    }
    .sluzba-2-intro-cols{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 60px;
    }
}

.block-container{
    padding: 92px;
}
.block-padding-lr{
    padding-left: 92px;
    padding-right: 92px;
}
.sluzba-intro{
    background-color: #020202;
    color: white;
    h1{
        font-size: 192px;
        line-height: 1;
        font-weight: 600;
        .red{
            color: red;
        }
        @media screen and (max-width: 1600px) {
            font-size: 120px;
        }
    }
}
.line{
    border-top: #252525 solid 1px ;
}
.intro-cols{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    .first-col{
        p{
            font-size: 42px;
            line-height: 1.3;
            max-width: 500px;

            @media screen and (max-width: 1600px) {
                font-size: 32px;
            }
        }
    }
    .second-col{
        p{
            font-size: 18px;
            line-height: 1.6;
            color: #888888;
            max-width: 500px;
        };
    }
}
.sluzby-2-reference{
    background-color: #cdcdcd;
    .sluzby-reference-item{
        border-top: solid 1px rgb(192, 192, 192);
        padding-right: 0px !important;
        .reference-item-layout{
            display: grid;
            grid-template-columns: 1.2fr 2fr;
            gap: 32px;
            padding-right: 0px;
            overflow: hidden;
            img{
                max-width: 120%;
            }
        }
    }
}

.reference-item-padding-lr{
    padding-left: 92px;
    padding-right: 92px;
}
.reference-item-padding-tb{
    padding-top: 92px;
    padding-bottom: 92px;
}
.sluzby-reference-label{
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 42px;
    opacity: .4;
}
.reference-item-1{
    grid-area: item1;
    // aspect-ratio: 1;
    background-color: #202020;
    color: white;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    img{
        margin-top: auto;
        margin-top: 60px;
        margin-left: -50%;
        margin-right: -15%;
    }
}
.reference-item-2{
    grid-area: item2;
    background-color:white;
    color: black;

    display: flex;
    flex-direction: column;

    width: 100%;
    overflow: hidden;
    padding-bottom: 0px;
    img{
        margin-top: auto;
        margin-top: 120px;
        margin-bottom: 160px;
        margin-left: -15%;
        margin-right: -15%;
    }
}
.reference-item-3{
    grid-area: item3;
    background-color: #bfbfbf;
    color: white;

    display: grid;
    grid-template-columns: 1.5fr 2fr;
    gap: 50px;
    /*
    padding-right: 0px;
    */
    overflow: hidden;

    background-position: center;
    .reference-item-3-img-wrapper{
        text-align: right;
        img{
            width: 90%;
        }
    }
}
.reference-item-3-text{
    padding-right: 60px;
}
.sluzby-reference-grid{
    display: grid;
    grid-template-areas: 
    "item1 item2"
    "item3 item3";
    position: relative;
    img{
        max-width: 100%;
    }
    .reference-item-3 img{
        max-width: 110%;
    }
    .reference-item-2 img,
    .reference-item-1 img{
        max-width: 250%;
    }
    @media screen and (max-width: 1400px) {
        grid-template-areas: 
        "item1"
        "item2"
        "item3";
    }
}
.sluzby-reference-item{
    z-index: 1;
    h2{
        font-size: 50px;
        font-weight: 600;
        margin-bottom: 42px;
    }
    p{
        line-height: 1.6;
        font-size: 18px;
        opacity: .7;
    }

    &.sluzby-reference-item--web {
        aspect-ratio: 1345/825;
        background: none;

        .sluzby-reference-item--web__logo {
            margin-bottom: 30px;
        }

        .sluzby-reference-item--web__content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            &.sluzby-reference-item--web__content--l {
                padding-right: 30px;
            }

            &.sluzby-reference-item--web__content--r {
                padding-left: 30px;
            }
        }
    }
}

.sluzby-reference-item--web-media {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    right: auto;
    bottom: auto;
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
    z-index: 0;

    .sluzby-reference-item--web-media__image {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: auto;
        height: auto;
        min-width: 100%;
        min-height: 100%;
        object-fit: cover;
        opacity: 1;
        transition: opacity 0.3s;
    }

    .sluzby-reference-item--web-media__yt-video {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: auto;
        width: auto;
        height: auto;
        aspect-ratio: 1345/825;
        overflow: hidden;
        opacity: 0;
        transition: opacity 0.3s;

        iframe {
            width: 110%;
            height: 120%;
            position: absolute;
            top: -10%;
            left: -5%;
            bottom: -10%;
            right: -5%;
            margin: 0 auto;
        }
    }

    &.sluzby-reference-item--web-media--video-loaded {
        .sluzby-reference-item--web-media__image {
            opacity: 0;
        }

        .sluzby-reference-item--web-media__yt-video {
            opacity: 1;
        }
    }
}

.sluzby-reference-grid {
    &#reference-oooox {
        h2 {
            color: #FFFFFF;
        }

        p {
            color: #FFFFFF;
        }
    }

    &#reference-sonet {
        h2 {
            color: #FFFFFF;
        }

        p {
            color: #FFFFFF;
        }
    }

    &#reference-cofee {
        h2 {
            color: #FFFFFF;
        }

        p {
            color: #FFFFFF;
        }
    }

    &#reference-pzk {
        .sluzby-reference-item--web-media {
            .sluzby-reference-item--web-media__image {
                top: -19.5%;
                left: -5%;
                right: 0;
                bottom: 0;
                aspect-ratio: 1919/1286;
                width: 105%;
                height: 119.5%;
                max-width: 105%;
                max-height: 119.5%;
            }
        }

        h2 {
            color: #1B2274;
        }

        p {
            color: #1B2274;
        }
    }
}
</style>